var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.004 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 50905"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.004 0h64v64h-64z",
    "data-name": "Rectangle 16278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M31.781 58.485v-7.5L50.5 32.265l7.5 7.5-18.716 18.716ZM0 40.828v-7.062h24.719v7.063Zm60.473-3.531-7.5-7.5 2.56-2.56a3.349 3.349 0 0 1 2.472-.971 3.349 3.349 0 0 1 2.472.971l2.56 2.56a3.348 3.348 0 0 1 .971 2.472 3.348 3.348 0 0 1-.971 2.472ZM0 26.703v-7.062h38.844v7.062Zm0-14.125V5.516h38.844v7.062Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPencil);
export default __webpack_public_path__ + "static/media/list-pencil.7f91aa6e94d45a26a4cea1c243f73312.svg";
export { ForwardRef as ReactComponent };